import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDashboard, getAdminOrders, updateOrderStatus, getAdminUsers, getOrderDetail, getMonthlySales, getStatsByPeriod, getAdminProducts, updateProduct, deleteProduct, createProduct, getCategories, getProductOptions, addProductOption, deleteProductOption, updateShippingInfo, deleteProductImage } from '../api/adminApi';
import { isLoggedIn } from '../utils/tokenUtils';
import styles from './AdminPage.module.css';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import Underline from '@tiptap/extension-underline';
import { getProduct } from '../api/productApi';
import { getSettings, updateSettings } from '../api/settingsApi';
import { getAllBanners, createBanner, updateBanner, deleteBanner } from '../api/bannerApi';
import { getAllEvents, createEvent, updateEvent, deleteEvent } from '../api/eventApi';
import { getAllNoticeBanners, createNoticeBanner, updateNoticeBanner, deleteNoticeBanner } from '../api/noticeBannerApi';
import { getAdminCategories,createCategory,updateCategory,deleteCategory } from '../api/adminApi';
import { getAllNavMenus, createNavMenu, updateNavMenu, deleteNavMenu } from '../api/navMenuApi';
import axios from 'axios';
import { getToken } from '../utils/tokenUtils';
import { getAllReviews, deleteReview } from '../api/reviewApi';
import { useModal } from '../context/ModalContext';
import * as XLSX from 'xlsx';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';


function RichEditor({ value, onChange }) {
    const editor = useEditor({
        extensions: [StarterKit, Underline, Image],
        content: value,
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        }
    });

    const uploadImage = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('imageFile', file);
        try {
            const res = await fetch(`${API_URL}/api/products/editor-image`, {
                method: 'POST',
                body: formData,
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            const data = await res.json();
            editor.chain().focus().setImage({ src: `${API_URL}${data.imageUrl}` }).run();
        } catch {
            console.error('이미지 업로드 실패');
        }
    };

    if (!editor) return null;

    const btnStyle = (active) => ({
        padding: '4px 8px',
        background: active ? '#000' : 'white',
        color: active ? 'white' : '#333',
        border: '1px solid #ddd',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '13px'
    });

    return (
        <div style={{ border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden' }}>
            <div style={{ display: 'flex', gap: '4px', padding: '8px', borderBottom: '1px solid #eee', flexWrap: 'wrap', background: '#f9f9f9' }}>
                <button type="button" onClick={() => editor.chain().focus().toggleBold().run()} style={{ ...btnStyle(editor.isActive('bold')), fontWeight: 'bold' }}>B</button>
                <button type="button" onClick={() => editor.chain().focus().toggleItalic().run()} style={{ ...btnStyle(editor.isActive('italic')), fontStyle: 'italic' }}>I</button>
                <button type="button" onClick={() => editor.chain().focus().toggleUnderline().run()} style={{ ...btnStyle(editor.isActive('underline')), textDecoration: 'underline' }}>U</button>
                <button type="button" onClick={() => editor.chain().focus().toggleBulletList().run()} style={btnStyle(editor.isActive('bulletList'))}>• 목록</button>
                <button type="button" onClick={() => editor.chain().focus().toggleOrderedList().run()} style={btnStyle(editor.isActive('orderedList'))}>1. 목록</button>
                <label style={{ ...btnStyle(false), display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    🖼 이미지
                    <input type="file" accept="image/*" onChange={uploadImage} style={{ display: 'none' }} />
                </label>
                <button type="button" onClick={() => editor.chain().focus().unsetAllMarks().clearNodes().run()} style={btnStyle(false)}>지우기</button>
            </div>
            <EditorContent editor={editor} style={{ padding: '12px', minHeight: '150px', fontSize: '14px' }} />
        </div>
    );
}

function AdminPage() {
    const navigate = useNavigate();
    const { showAlert, showConfirm } = useModal();
    const [activeTab, setActiveTab] = useState('dashboard');
    const [dashboard, setDashboard] = useState(null);
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderDetailLoading, setOrderDetailLoading] = useState(false);
    const [monthlySales, setMonthlySales] = useState([]);
    const [chartYear, setChartYear] = useState(new Date().getFullYear());
    const [statsPeriod, setStatsPeriod] = useState('all');
    const [periodStats, setPeriodStats] = useState(null);
    const [userSearch, setUserSearch] = useState('');
    const [products, setProducts] = useState([]);
    const [productSearch, setProductSearch] = useState('');
    const [showProductForm, setShowProductForm] = useState(false);
    const [categories, setCategories] = useState([]);
    const [productForm, setProductForm] = useState({
        name: '', description: '', price: '', originalPrice: '',
        discountRate: '0', stock: '', categoryId: '', status: 'ON_SALE',
        shippingInfo: '', deliveryFee: ''
    });
    const [productImageFile, setProductImageFile] = useState(null);
    const [productImageFiles, setProductImageFiles] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editForm, setEditForm] = useState(null);
    const [productOptions, setProductOptions] = useState([]);
    const [newOption, setNewOption] = useState({ optionName: '', optionValue: '', additionalPrice: 0, stock: 0 });
    const [statusFilter, setStatusFilter] = useState('ALL');
    const [periodFilter, setPeriodFilter] = useState('all');
    const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
    const [siteSettings, setSiteSettings] = useState({});
    const [settingsForm, setSettingsForm] = useState({});
    const [editImageFile, setEditImageFile] = useState(null);
    const [editImageFiles, setEditImageFiles] = useState([]);
    const [banners, setBanners] = useState([]);
    const [showBannerForm, setShowBannerForm] = useState(false);
    const [bannerForm, setBannerForm] = useState({ title: '', linkType: 'NONE', linkValue: '', sortOrder: 0, isActive: true });
    const [bannerImageFile, setBannerImageFile] = useState(null);
    const [editingBanner, setEditingBanner] = useState(null);
    const [events, setEvents] = useState([]);
    const [showEventForm, setShowEventForm] = useState(false);
    const [eventForm, setEventForm] = useState({ title: '', content: '', isActive: true });
    const [eventThumbnailFile, setEventThumbnailFile] = useState(null);
    const [editingEvent, setEditingEvent] = useState(null);
    const [noticeBanners, setNoticeBanners] = useState([]);
    const [showNoticeBannerForm, setShowNoticeBannerForm] = useState(false);
    const [noticeBannerForm, setNoticeBannerForm] = useState({ content: '', bgColor: '#111111', textColor: '#ffffff', linkType: 'NONE', linkValue: '', sortOrder: 0, isActive: true });
    const [editingNoticeBanner, setEditingNoticeBanner] = useState(null);
    const [categoryTree, setCategoryTree] = useState([]);
    const [showCategoryForm, setShowCategoryForm] = useState(false);
    const [categoryForm, setCategoryForm] = useState({ name: '', parentId: '' });
    const [editingCategory, setEditingCategory] = useState(null);
    const [editingCategoryName, setEditingCategoryName] = useState('');
    const statusLabels = {
        PENDING: '결제 대기', PAID: '결제 완료',
        SHIPPING: '배송 중', DELIVERED: '배송 완료', CANCELLED: '취소'
    };
    const [navMenus, setNavMenus] = useState([]);
    const [showNavMenuForm, setShowNavMenuForm] = useState(false);
    const [navMenuForm, setNavMenuForm] = useState({ label: '', linkType: 'NONE', linkValue: '', sortOrder: 0, isActive: true });
    const [editingNavMenu, setEditingNavMenu] = useState(null);
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);
    const [boards, setBoards] = useState([]);
    const [boardSearch, setBoardSearch] = useState('');
    const [reviews, setReviews] = useState([]);
    const [reviewSearch, setReviewSearch] = useState('');
    const [shippingForm, setShippingForm] = useState({ courierName: '', trackingNumber: '' });
    const [productPage, setProductPage] = useState(1);
    const PRODUCTS_PER_PAGE = 10;
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [bulkStatus, setBulkStatus] = useState(null);

    useEffect(() => {
        if (!isLoggedIn()) { navigate('/login'); return; }
        loadData();
    }, []);

    useEffect(() => {
        applyFilters();
    }, [orders, statusFilter, periodFilter, yearFilter]);

    const loadData = async () => {
        try {
            const [orderRes, userRes] = await Promise.all([getAdminOrders(), getAdminUsers()]);
            setOrders(orderRes.data);
            setUsers(userRes.data);
        } catch (err) { console.error('주문/회원 에러:', err); }
        try {
            const [dashRes, monthlyRes, periodRes] = await Promise.all([
                getDashboard(), getMonthlySales(new Date().getFullYear()), getStatsByPeriod('all')
            ]);
            setDashboard(dashRes.data);
            setMonthlySales(monthlyRes.data);
            setPeriodStats(periodRes.data);
        } catch (err) { console.error('대시보드 에러:', err); }
        try {
            const productRes = await getAdminProducts();
            setProducts(productRes.data);
        } catch (err) { console.error('상품 로딩 실패', err); }
        try {
            const categoryRes = await getCategories();
            setCategories(categoryRes.data);
        } catch (err) { console.error('카테고리 로딩 실패', err); }
        try {
            const settingsRes = await getSettings();
            setSiteSettings(settingsRes.data);
            setSettingsForm(settingsRes.data);
        } catch (err) { console.error('설정 로딩 실패', err); }
        try {
            const [bannersRes, eventsRes] = await Promise.all([getAllBanners(), getAllEvents()]);
            setBanners(bannersRes.data);
            setEvents(eventsRes.data);
        } catch (err) { console.error('배너/이벤트 로딩 실패', err); }
        try {
            const noticeBannersRes = await getAllNoticeBanners();
            setNoticeBanners(noticeBannersRes.data);
        } catch (err) { console.error('띠 배너 로딩 실패', err); }
        try {
            const categoryTreeRes = await getAdminCategories();
            setCategoryTree(categoryTreeRes.data);
        } catch (err) { console.error('카테고리 트리 로딩 실패', err); }
        try {
            const navMenusRes = await getAllNavMenus();
            setNavMenus(navMenusRes.data);
        } catch (err) { console.error('네비 메뉴 로딩 실패', err); }
        try {
            const boardsRes = await axios.get(`${API_URL}/api/boards?size=100`, {
                headers: { Authorization: `Bearer ${getToken()}` }
            });
            setBoards(boardsRes.data.boards || []);
        } catch (err) { console.error('게시판 로딩 실패', err); }
        try {
            const reviewsRes = await getAllReviews();
            setReviews(reviewsRes.data);
        } catch (err) { console.error('리뷰 로딩 실패', err); }
        setLoading(false);
    };

    const applyFilters = () => {
        let result = [...orders];
        if (statusFilter !== 'ALL') result = result.filter(o => o.status === statusFilter);
        const now = new Date();
        if (periodFilter === 'today') result = result.filter(o => new Date(o.createdAt).toDateString() === now.toDateString());
        else if (periodFilter === 'week') result = result.filter(o => new Date(o.createdAt) >= new Date(now - 7 * 24 * 60 * 60 * 1000));
        else if (periodFilter === 'month') result = result.filter(o => { const d = new Date(o.createdAt); return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear(); });
        else if (periodFilter === 'year') result = result.filter(o => new Date(o.createdAt).getFullYear() === parseInt(yearFilter));
        setFilteredOrders(result);
    };

    const handleStatusChange = async (orderId, status) => {
        try {
            await updateOrderStatus(orderId, status);
            setOrders(orders.map(o => o.orderId === orderId ? { ...o, status } : o));
        } catch { await showAlert('상태 변경에 실패했습니다.', 'error'); }
    };

    const handleBulkStatusChange = async (status) => {
        if (selectedOrders.length === 0) { await showAlert('주문을 선택해 주세요.', 'warning'); return; }
        if (!status) { await showAlert('변경할 상태를 선택해 주세요.', 'warning'); return; }
        const ok = await showConfirm(`선택한 ${selectedOrders.length}건의 주문 상태를 "${statusLabels[status]}"(으)로 변경하시겠습니까?`);
        if (!ok) return;
        try {
            await Promise.all(selectedOrders.map(orderId => updateOrderStatus(orderId, status)));
            setOrders(orders.map(o =>
                selectedOrders.includes(o.orderId) ? { ...o, status } : o
            ));
            setSelectedOrders([]);
            setBulkStatus(null);
            await showAlert('상태가 변경되었습니다.', 'success');
        } catch (err) {
            console.error('일괄변경 에러:', err);
            await showAlert('일부 주문 변경에 실패했습니다.', 'error');
        }
    };

    const handleExcelDownload = () => {
    const data = filteredOrders.map(order => ({
            '주문번호': order.orderId,
            '주문자': order.userName,
            '이메일': order.userEmail,
            '금액': order.totalPrice,
            '상태': statusLabels[order.status],
            '주문일': new Date(order.createdAt).toLocaleDateString(),
            '택배사': order.courierName || '',
            '운송장번호': order.trackingNumber || '',
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '주문목록');

        const today = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(wb, `주문목록_${today}.xlsx`);
    };
    

    const handleSelectOrder = (orderId) => {
        setSelectedOrders(prev =>
            prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]
        );
    };

    const handleSelectAllOrders = () => {
        if (selectedOrders.length === filteredOrders.length) {
            setSelectedOrders([]);
        } else {
            setSelectedOrders(filteredOrders.map(o => o.orderId));
        }
    };
    const handleOrderClick = async (orderId) => {
        setOrderDetailLoading(true);
        try {
            const res = await getOrderDetail(orderId);
            setSelectedOrder(res.data);
            setShippingForm({
                courierName: res.data.courierName || '',
                trackingNumber: res.data.trackingNumber || ''
            });
        } catch { await showAlert('주문 상세 조회에 실패했습니다.', 'error'); }
        finally { setOrderDetailLoading(false); }
    };

    const handleChartYearChange = async (year) => {
        setChartYear(year);
        try { const res = await getMonthlySales(year); setMonthlySales(res.data); }
        catch (err) { console.error('월별 매출 로딩 실패', err); }
    };

    const handleStatsPeriodChange = async (period) => {
        setStatsPeriod(period);
        try { const res = await getStatsByPeriod(period); setPeriodStats(res.data); }
        catch (err) { console.error('기간별 통계 로딩 실패', err); }
    };

    const handleProductEdit = async (product) => {
        setEditForm({ ...product, shippingInfo: product.shippingInfo || '', categoryId: product.categoryId || '' });
        setShowEditModal(true);
        try {
            const res = await getProduct(product.productId);
            setProductOptions(res.data.options || []);
            setEditForm(prev => ({ ...prev, images: res.data.images || [] }));
        } catch { setProductOptions([]); }
    };

    const handleAddOption = async () => {
        if (!newOption.optionName || !newOption.optionValue) { await showAlert('옵션명과 옵션값을 입력해주세요.', 'warning'); return; }
        try {
            const res = await addProductOption(editForm.productId, newOption);
            setProductOptions(prev => [...prev, res.data]);
            setNewOption({ optionName: '', optionValue: '', additionalPrice: 0, stock: 0 });
        } catch { await showAlert('옵션 추가에 실패했습니다.', 'error'); }
    };

    const handleDeleteOption = async (optionId) => {
        const ok = await showConfirm('옵션을 삭제하시겠습니까?');
        if (!ok) return;
        try {
            await deleteProductOption(editForm.productId, optionId);
            setProductOptions(prev => prev.filter(o => o.optionId !== optionId));
        } catch { await showAlert('옵션 삭제에 실패했습니다.', 'error'); }
    };

    const handleProductSave = async () => {
        try {
            const formData = new FormData();
            formData.append('price', editForm.price);
            formData.append('stock', editForm.stock);
            formData.append('status', editForm.status);
            formData.append('description', editForm.description || '');
            formData.append('shippingInfo', editForm.shippingInfo || '');
            if (editForm.originalPrice) formData.append('originalPrice', editForm.originalPrice);
            if (editForm.discountRate !== undefined) formData.append('discountRate', editForm.discountRate);
            if (editImageFile) formData.append('imageFile', editImageFile);
            if (editForm.categoryId) formData.append('categoryId', editForm.categoryId);
            if (editForm.deliveryFee !== undefined) formData.append('deliveryFee', editForm.deliveryFee || '');
            if (editForm.name) formData.append('name', editForm.name);
            editImageFiles.forEach(f => formData.append('imageFiles', f));
            await updateProduct(editForm.productId, formData);
            setProducts(products.map(p => p.productId === editForm.productId ? { ...p, ...editForm } : p));
            setShowEditModal(false);
            setEditForm(null);
            setEditImageFile(null);
            setEditImageFiles([]);
            await showAlert('수정되었습니다.', 'success');
        } catch { await showAlert('수정에 실패했습니다.', 'error'); }
    };

    const handleProductDelete = async (productId) => {
        const ok = await showConfirm('정말 삭제하시겠습니까?');
        if (!ok) return;
        try {
            await deleteProduct(productId);
            setProducts(products.filter(p => p.productId !== productId));
            await showAlert('삭제되었습니다.', 'success');
        } catch { await showAlert('삭제에 실패했습니다.', 'error'); }
    };

    const handleProductFormChange = (e) => {
        const { name, value } = e.target;
        setProductForm(prev => ({ ...prev, [name]: value }));
    };

    const handleCreateProduct = async () => {
        if (!productForm.name || !productForm.price || !productForm.stock || !productForm.categoryId) {
            await showAlert('필수 항목을 입력해주세요.', 'warning'); return;
        }
        try {
            const formData = new FormData();
            formData.append('name', productForm.name);
            formData.append('description', productForm.description);
            formData.append('price', productForm.price);
            formData.append('categoryId', productForm.categoryId);
            formData.append('stock', productForm.stock);
            formData.append('discountRate', productForm.discountRate || '0');
            formData.append('shippingInfo', productForm.shippingInfo);
            if (productForm.originalPrice) formData.append('originalPrice', productForm.originalPrice);
            if (productImageFile) formData.append('imageFile', productImageFile);
            if (productForm.deliveryFee !== undefined) formData.append('deliveryFee', productForm.deliveryFee || '');
            productImageFiles.forEach(f => formData.append('imageFiles', f));
            const res = await createProduct(formData);
            setProducts(prev => [res.data, ...prev]);
            setShowProductForm(false);
            setProductForm({ name: '', description: '', price: '', originalPrice: '', discountRate: '0', stock: '', categoryId: '', status: 'ON_SALE', shippingInfo: '', deliveryFee: '' });
            setProductImageFile(null); setProductImageFiles([]);
            await showAlert('상품이 등록되었습니다.', 'success');
        } catch { await showAlert('상품 등록에 실패했습니다.', 'error'); }
    };

    const handleSettingsSave = async () => {
        try {
            await updateSettings(settingsForm);
            setSiteSettings(settingsForm);
            await showAlert('저장되었습니다.', 'success');
        } catch { await showAlert('저장에 실패했습니다.', 'error'); }
    };

    const handleBannerSubmit = async () => {
        if (!bannerImageFile && !editingBanner) { await showAlert('이미지를 선택해주세요.', 'warning'); return; }
        try {
            const formData = new FormData();
            formData.append('title', bannerForm.title);
            formData.append('linkType', bannerForm.linkType);
            formData.append('linkValue', bannerForm.linkValue);
            formData.append('sortOrder', bannerForm.sortOrder);
            formData.append('isActive', bannerForm.isActive);
            if (bannerImageFile) formData.append('image', bannerImageFile);
            if (editingBanner) {
                const res = await updateBanner(editingBanner.bannerId, formData);
                setBanners(banners.map(b => b.bannerId === editingBanner.bannerId ? res.data : b));
                await showAlert('배너가 수정되었습니다.', 'success');
            } else {
                const res = await createBanner(formData);
                setBanners(prev => [...prev, res.data]);
                await showAlert('배너가 등록되었습니다.', 'success');
            }
            setShowBannerForm(false); setEditingBanner(null);
            setBannerForm({ title: '', linkType: 'NONE', linkValue: '', sortOrder: 0, isActive: true });
            setBannerImageFile(null);
        } catch { await showAlert('배너 저장에 실패했습니다.', 'error'); }
    };

    const handleBannerEdit = (banner) => {
        setEditingBanner(banner);
        setBannerForm({ title: banner.title || '', linkType: banner.linkType || 'NONE', linkValue: banner.linkValue || '', sortOrder: banner.sortOrder || 0, isActive: banner.isActive });
        setShowBannerForm(true);
    };

    const handleBannerDelete = async (bannerId) => {
        const ok = await showConfirm('배너를 삭제하시겠습니까?');
        if (!ok) return;
        try {
            await deleteBanner(bannerId);
            setBanners(banners.filter(b => b.bannerId !== bannerId));
        } catch { await showAlert('삭제에 실패했습니다.', 'error'); }
    };

    const handleEventSubmit = async () => {
        if (!eventForm.title) { await showAlert('제목을 입력해주세요.', 'warning'); return; }
        try {
            const formData = new FormData();
            formData.append('title', eventForm.title);
            formData.append('content', eventForm.content || '');
            formData.append('isActive', eventForm.isActive);
            if (eventThumbnailFile) formData.append('thumbnail', eventThumbnailFile);
            if (editingEvent) {
                const res = await updateEvent(editingEvent.eventId, formData);
                setEvents(events.map(e => e.eventId === editingEvent.eventId ? res.data : e));
                await showAlert('이벤트가 수정되었습니다.', 'success');
            } else {
                const res = await createEvent(formData);
                setEvents(prev => [res.data, ...prev]);
                await showAlert('이벤트가 등록되었습니다.', 'success');
            }
            setShowEventForm(false); setEditingEvent(null);
            setEventForm({ title: '', content: '', isActive: true });
            setEventThumbnailFile(null);
        } catch { await showAlert('이벤트 저장에 실패했습니다.', 'error'); }
    };

    const handleEventEdit = (event) => {
        setEditingEvent(event);
        setEventForm({ title: event.title, content: event.content || '', isActive: event.isActive });
        setShowEventForm(true);
    };

    const handleEventDelete = async (eventId) => {
        const ok = await showConfirm('이벤트를 삭제하시겠습니까?');
        if (!ok) return;
        try {
            await deleteEvent(eventId);
            setEvents(events.filter(e => e.eventId !== eventId));
        } catch { await showAlert('삭제에 실패했습니다.', 'error'); }
    };

    const handlePrintInvoice = (order) => {
        const invoiceWindow = window.open('', '_blank', 'width=400,height=600');
        invoiceWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <title>송장 #${order.orderId}</title>
                <style>
                    * { margin: 0; padding: 0; box-sizing: border-box; }
                    body { font-family: 'Malgun Gothic', sans-serif; padding: 20px; }
                    .invoice { border: 2px solid #000; width: 360px; margin: 0 auto; }
                    .header { background: #000; color: white; text-align: center; padding: 10px; font-size: 18px; font-weight: bold; letter-spacing: 4px; }
                    .section { border-bottom: 1px solid #000; padding: 10px 14px; }
                    .section:last-child { border-bottom: none; }
                    .label { font-size: 10px; color: #666; margin-bottom: 4px; }
                    .value { font-size: 13px; font-weight: bold; }
                    .value-sm { font-size: 12px; }
                    .row { display: flex; justify-content: space-between; align-items: flex-start; }
                    .barcode { text-align: center; padding: 10px; font-size: 11px; letter-spacing: 4px; border-top: 1px dashed #999; margin-top: 6px; }
                    .items { font-size: 11px; color: #333; margin-top: 4px; }
                    .divider { border-top: 2px dashed #000; margin: 0; }
                    @media print { body { padding: 0; } button { display: none; } }
                </style>
            </head>
            <body>
                <div class="invoice">
                    <div class="header">${siteSettings.shop_name || 'SHOP'} 택배</div>
                    <div class="section">
                        <div class="label">▶ 받는 분</div>
                        <div class="row">
                            <div class="value">${order.address?.recipient || order.user?.name || ''}</div>
                            <div class="value">${order.address?.phone || order.user?.phone || ''}</div>
                        </div>
                        <div class="value-sm" style="margin-top:4px">[${order.address?.zipcode || ''}] ${order.address?.address1 || ''} ${order.address?.address2 || ''}</div>
                    </div>
                    <hr class="divider">
                    <div class="section">
                        <div class="label">▶ 보내는 분</div>
                        <div class="row">
                            <div class="value">${siteSettings.shop_name || 'SHOP'}</div>
                            <div class="value-sm">${siteSettings.shop_phone || ''}</div>
                        </div>
                        <div class="value-sm" style="margin-top:4px">${siteSettings.shop_address || ''}</div>
                    </div>
                    <hr class="divider">
                    <div class="section">
                        <div class="label">▶ 주문 정보</div>
                        <div class="row">
                            <div class="value-sm">주문번호: ${order.orderId}</div>
                            <div class="value-sm">${new Date(order.createdAt).toLocaleDateString()}</div>
                        </div>
                        <div class="items">${order.orderItems?.map(i => `${i.productName} x${i.quantity}`).join(', ') || ''}</div>
                    </div>
                    <div class="barcode">ORD-${String(order.orderId).padStart(8, '0')}</div>
                </div>
                <div style="text-align:center; margin-top:16px;">
                    <button onclick="window.print()" style="padding:10px 30px; font-size:14px; cursor:pointer; background:#000; color:white; border:none; border-radius:4px;">🖨️ 인쇄하기</button>
                </div>
            </body>
            </html>
        `);
        invoiceWindow.document.close();
    };

    const handleNoticeBannerSubmit = async () => {
        if (!noticeBannerForm.content) { await showAlert('내용을 입력해주세요.', 'warning'); return; }
        try {
            if (editingNoticeBanner) {
                const res = await updateNoticeBanner(editingNoticeBanner.noticeBannerId, noticeBannerForm);
                setNoticeBanners(noticeBanners.map(b => b.noticeBannerId === editingNoticeBanner.noticeBannerId ? res.data : b));
                await showAlert('수정되었습니다.', 'success');
            } else {
                const res = await createNoticeBanner(noticeBannerForm);
                setNoticeBanners(prev => [...prev, res.data]);
                await showAlert('등록되었습니다.', 'success');
            }
            setShowNoticeBannerForm(false);
            setEditingNoticeBanner(null);
            setNoticeBannerForm({ content: '', bgColor: '#111111', textColor: '#ffffff', linkType: 'NONE', linkValue: '', sortOrder: 0, isActive: true });
        } catch { await showAlert('저장에 실패했습니다.', 'error'); }
    };

    const handleNoticeBannerEdit = (banner) => {
        setEditingNoticeBanner(banner);
        setNoticeBannerForm({
            content: banner.content,
            bgColor: banner.bgColor || '#111111',
            textColor: banner.textColor || '#ffffff',
            linkType: banner.linkType || 'NONE',
            linkValue: banner.linkValue || '',
            sortOrder: banner.sortOrder || 0,
            isActive: banner.isActive
        });
        setShowNoticeBannerForm(true);
    };

    const handleNoticeBannerDelete = async (id) => {
        const ok = await showConfirm('띠 배너를 삭제하시겠습니까?');
        if (!ok) return;
        try {
            await deleteNoticeBanner(id);
            setNoticeBanners(noticeBanners.filter(b => b.noticeBannerId !== id));
        } catch { await showAlert('삭제에 실패했습니다.', 'error'); }
    };

    const handleCreateCategory = async () => {
        if (!categoryForm.name) { await showAlert('카테고리명을 입력해주세요.', 'warning'); return; }
        try {
            const data = { name: categoryForm.name };
            if (categoryForm.parentId) data.parentId = categoryForm.parentId;
            await createCategory(data);
            await showAlert('카테고리가 등록되었습니다.', 'success');
            setShowCategoryForm(false);
            setCategoryForm({ name: '', parentId: '' });
            const updated = await getAdminCategories();
            setCategoryTree(updated.data);
        } catch (err) {
            await showAlert(err.response?.data?.message || '등록에 실패했습니다.', 'error');
        }
    };

    const handleUpdateCategory = async (categoryId) => {
        if (!editingCategoryName) { await showAlert('카테고리명을 입력해주세요.', 'warning'); return; }
        try {
            await updateCategory(categoryId, { name: editingCategoryName });
            setEditingCategory(null);
            setEditingCategoryName('');
            const updated = await getAdminCategories();
            setCategoryTree(updated.data);
        } catch (err) {
            await showAlert(err.response?.data?.message || '수정에 실패했습니다.', 'error');
        }
    };

    const handleDeleteCategory = async (categoryId) => {
        const ok = await showConfirm('카테고리를 삭제하시겠습니까?');
        if (!ok) return;
        try {
            await deleteCategory(categoryId);
            const updated = await getAdminCategories();
            setCategoryTree(updated.data);
        } catch (err) {
            await showAlert(err.response?.data?.message || '삭제에 실패했습니다.', 'error');
        }
    };

    const handleNavMenuSubmit = async () => {
        if (!navMenuForm.label) { await showAlert('메뉴명을 입력해주세요.', 'warning'); return; }
        try {
            if (editingNavMenu) {
                const res = await updateNavMenu(editingNavMenu.navMenuId, navMenuForm);
                setNavMenus(navMenus.map(m => m.navMenuId === editingNavMenu.navMenuId ? res.data : m));
                await showAlert('수정되었습니다.', 'success');
            } else {
                const res = await createNavMenu(navMenuForm);
                setNavMenus(prev => [...prev, res.data]);
                await showAlert('등록되었습니다.', 'success');
            }
            setShowNavMenuForm(false);
            setEditingNavMenu(null);
            setNavMenuForm({ label: '', linkType: 'NONE', linkValue: '', sortOrder: 0, isActive: true });
        } catch { await showAlert('저장에 실패했습니다.', 'error'); }
    };

    const handleNavMenuEdit = (menu) => {
        setEditingNavMenu(menu);
        setNavMenuForm({
            label: menu.label,
            linkType: menu.linkType || 'NONE',
            linkValue: menu.linkValue || '',
            sortOrder: menu.sortOrder || 0,
            isActive: menu.isActive
        });
        setShowNavMenuForm(true);
    };

    const handleNavMenuDelete = async (id) => {
        const ok = await showConfirm('메뉴를 삭제하시겠습니까?');
        if (!ok) return;
        try {
            await deleteNavMenu(id);
            setNavMenus(navMenus.filter(m => m.navMenuId !== id));
        } catch { await showAlert('삭제에 실패했습니다.', 'error'); }
    };

    if (loading) return <p style={{ textAlign: 'center', padding: '60px' }}>로딩 중...</p>;

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>관리자 페이지</h2>

            <div className={styles.tabs}>
                {['dashboard', 'orders', 'users', 'products', 'banners', 'events', 'notice', 'categories', 'navigation', 'boards', 'reviews', 'settings'].map(tab => (
                    <button key={tab} className={`${styles.tab} ${activeTab === tab ? styles.activeTab : ''}`} onClick={() => setActiveTab(tab)}>
                        {tab === 'dashboard' ? '대시보드' : tab === 'orders' ? '주문 관리' : tab === 'users' ? '회원 관리' : tab === 'products' ? '상품 관리' : tab === 'banners' ? '배너 관리' : tab === 'events' ? '이벤트 관리' : tab === 'notice' ? '띠 배너' : tab === 'categories' ? '카테고리' : tab === 'navigation' ? '네비게이션' : tab === 'boards' ? '게시판 관리' : tab === 'reviews' ? '리뷰 관리' : '사이트 설정'}
                    </button>
                ))}
            </div>

            {/* 대시보드 */}
            {activeTab === 'dashboard' && dashboard && (
                <div>
                    <div className={styles.periodFilter}>
                        {[{ key: 'all', label: '전체' }, { key: 'today', label: '오늘' }, { key: 'week', label: '이번주' }, { key: 'month', label: '이번달' }, { key: 'year', label: '올해' }].map(p => (
                            <button key={p.key} className={`${styles.filterBtn} ${statsPeriod === p.key ? styles.activeFilter : ''}`} onClick={() => handleStatsPeriodChange(p.key)}>{p.label}</button>
                        ))}
                    </div>
                    <div className={styles.statsGrid}>
                        <div className={styles.statCard}><p className={styles.statLabel}>총 회원수</p><p className={styles.statValue}>{dashboard.totalUsers}명</p><p className={styles.statSub}>전체 누적</p></div>
                        <div className={styles.statCard}><p className={styles.statLabel}>신규 가입</p><p className={styles.statValue}>{periodStats?.newUsers ?? 0}명</p><p className={styles.statSub}>선택 기간 내</p></div>
                        <div className={styles.statCard}><p className={styles.statLabel}>주문수</p><p className={styles.statValue}>{periodStats?.totalOrders ?? dashboard.totalOrders}건</p><p className={styles.statSub}>선택 기간 내</p></div>
                        <div className={styles.statCard}><p className={styles.statLabel}>매출</p><p className={styles.statValue}>{(periodStats?.totalRevenue ?? dashboard.totalRevenue)?.toLocaleString()}원</p><p className={styles.statSub}>선택 기간 내</p></div>
                    </div>
                    <div className={styles.chartSection}>
                        <div className={styles.chartHeader}>
                            <h3 className={styles.sectionTitle}>월별 매출</h3>
                            <div className={styles.yearSelector}>
                                {yearOptions.map(y => (
                                    <button key={y} className={`${styles.filterBtn} ${chartYear === y ? styles.activeFilter : ''}`} onClick={() => handleChartYearChange(y)}>{y}년</button>
                                ))}
                            </div>
                        </div>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={monthlySales} margin={{ top: 10, right: 10, left: 20, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                <YAxis tickFormatter={v => v === 0 ? '0' : (v / 10000) + '만'} tick={{ fontSize: 12 }} />
                                <Tooltip formatter={v => v.toLocaleString() + '원'} />
                                <Bar dataKey="revenue" fill="#000" radius={[4, 4, 0, 0]} name="매출" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <h3 className={styles.sectionTitle}>베스트 상품</h3>
                    <table className={styles.table}>
                        <thead><tr><th>순위</th><th>상품명</th><th>판매수량</th><th>매출</th></tr></thead>
                        <tbody>
                            {dashboard.bestProducts?.map((p, i) => (
                                <tr key={i}><td>{i + 1}</td><td>{p.productName}</td><td>{p.totalQuantity}개</td><td>{Number(p.totalRevenue)?.toLocaleString()}원</td></tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 주문 관리 */}
            {activeTab === 'orders' && (
                <div>
                    <div className={styles.filterBar}>
                        <div className={styles.filterGroup}>
                            <span className={styles.filterLabel}>상태</span>
                            {['ALL', 'PENDING', 'PAID', 'SHIPPING', 'DELIVERED', 'CANCELLED'].map(s => (
                                <button key={s} className={`${styles.filterBtn} ${statusFilter === s ? styles.activeFilter : ''}`} onClick={() => setStatusFilter(s)}>
                                    {s === 'ALL' ? '전체' : statusLabels[s]}
                                </button>
                            ))}
                        </div>
                        <div className={styles.filterGroup}>
                            <span className={styles.filterLabel}>기간</span>
                            {['all', 'today', 'week', 'month', 'year'].map(p => (
                                <button key={p} className={`${styles.filterBtn} ${periodFilter === p ? styles.activeFilter : ''}`} onClick={() => setPeriodFilter(p)}>
                                    {p === 'all' ? '전체' : p === 'today' ? '오늘' : p === 'week' ? '이번주' : p === 'month' ? '이번달' : '연도별'}
                                </button>
                            ))}
                            {periodFilter === 'year' && (
                                <select value={yearFilter} onChange={e => setYearFilter(e.target.value)} className={styles.select}>
                                    {yearOptions.map(y => <option key={y} value={y}>{y}년</option>)}
                                </select>
                            )}
                        </div>
                    </div>
                    <div className={styles.bulkActions} onClick={e => e.stopPropagation()}>
                        <label className={styles.checkLabel}>
                            <input type="checkbox"
                                checked={selectedOrders.length === filteredOrders.length && filteredOrders.length > 0}
                                onChange={handleSelectAllOrders} />
                            전체 선택 ({selectedOrders.length}/{filteredOrders.length})
                        </label>
                        {selectedOrders.length > 0 && (
                            <div className={styles.bulkRight}>
                                {Object.entries(statusLabels).map(([val, label]) => (
                                    <button
                                        key={val}
                                        onClick={(e) => { e.stopPropagation(); handleBulkStatusChange(val); }}
                                        style={{
                                            padding: '4px 10px',
                                            background: 'white',
                                            color: '#333',
                                            border: '1px solid #ddd',   
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}>
                                        {label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                        <button className={styles.saveBtn} onClick={handleExcelDownload}>
                            📥 엑셀 다운로드
                        </button>
                    </div>
                    <p className={styles.resultCount}>총 {filteredOrders.length}건</p>
                    <table className={styles.table}>
                        <thead><tr><th></th><th>주문번호</th><th>회원</th><th>금액</th><th>상태</th><th>주문일</th><th>변경</th></tr></thead>
                        <tbody>
                            {filteredOrders.map(order => (
                                <tr key={order.orderId} className={styles.clickableRow} onClick={() => handleOrderClick(order.orderId)}>
                                    <td onClick={e => e.stopPropagation()}>
                                        <input type="checkbox"
                                            checked={selectedOrders.includes(order.orderId)}
                                            onChange={() => handleSelectOrder(order.orderId)} />
                                    </td>
                                    <td>{order.orderId}</td>
                                    <td>{order.userName}<br /><span className={styles.subText}>{order.userEmail}</span></td>
                                    <td>{order.totalPrice?.toLocaleString()}원</td>
                                    <td>{statusLabels[order.status]}</td>
                                    <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        <select value={order.status} onClick={e => e.stopPropagation()}
                                            onChange={e => handleStatusChange(order.orderId, e.target.value)} className={styles.select}>
                                            {Object.entries(statusLabels).map(([val, label]) => (
                                                <option key={val} value={val}>{label}</option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 회원 관리 */}
            {activeTab === 'users' && (
                <div>
                    <div className={styles.searchBar}>
                        <input type="text" placeholder="이름 또는 이메일 검색" value={userSearch}
                            onChange={e => setUserSearch(e.target.value)} className={styles.searchInput} />
                    </div>
                    <p className={styles.resultCount}>총 {users.filter(u => u.name?.includes(userSearch) || u.email?.includes(userSearch)).length}명</p>
                    <table className={styles.table}>
                        <thead><tr><th>ID</th><th>이름</th><th>이메일</th><th>전화번호</th><th>권한</th><th>가입일</th></tr></thead>
                        <tbody>
                            {users.filter(u => u.name?.includes(userSearch) || u.email?.includes(userSearch)).map(user => (
                                <tr key={user.userId}>
                                    <td>{user.userId}</td><td>{user.name}</td><td>{user.email}</td>
                                    <td>{user.phone}</td><td>{user.role}</td>
                                    <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 상품 관리 */}
            {activeTab === 'products' && (
                <div>
                    <div className={styles.productHeader}>
                        <div className={styles.searchBar}>
                            <input type="text" placeholder="상품명 검색" value={productSearch}
                                onChange={e => { setProductSearch(e.target.value); setProductPage(1); }}
                                className={styles.searchInput} />
                        </div>
                        <button className={styles.saveBtn} onClick={() => setShowProductForm(true)}>+ 상품 등록</button>
                    </div>
                    {(() => {
                        const filtered = products.filter(p => p.name?.includes(productSearch));
                        const totalPages = Math.ceil(filtered.length / PRODUCTS_PER_PAGE);
                        const paginated = filtered.slice((productPage - 1) * PRODUCTS_PER_PAGE, productPage * PRODUCTS_PER_PAGE);
                        return (
                            <>
                                <p className={styles.resultCount}>총 {filtered.length}개</p>
                                <table className={styles.table}>
                                    <thead><tr><th>이미지</th><th>상품명</th><th>카테고리</th><th>가격</th><th>재고</th><th>상태</th><th>관리</th></tr></thead>
                                    <tbody>
                                        {paginated.map(product => (
                                            <tr key={product.productId}>
                                                <td><img src={`${API_URL}${product.imageUrl}`} alt={product.name} className={styles.productThumb} /></td>
                                                <td>{product.name}</td>
                                                <td>{product.categoryName}</td>
                                                <td>{product.price?.toLocaleString()}원</td>
                                                <td>{product.stock}개</td>
                                                <td><span className={styles[`status_${product.status}`]}>{product.status === 'ON_SALE' ? '판매중' : product.status === 'SOLD_OUT' ? '품절' : '숨김'}</span></td>
                                                <td>
                                                    <div className={styles.btnGroup}>
                                                        <button className={styles.editBtn} onClick={() => handleProductEdit(product)}>수정</button>
                                                        <button className={styles.deleteBtn} onClick={() => handleProductDelete(product.productId)}>삭제</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {totalPages > 1 && (
                                    <div className={styles.pagination}>
                                        <button className={styles.pageBtn} onClick={() => setProductPage(p => Math.max(1, p - 1))} disabled={productPage === 1}>이전</button>
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                            <button key={page} className={`${styles.pageBtn} ${productPage === page ? styles.pageBtnActive : ''}`} onClick={() => setProductPage(page)}>{page}</button>
                                        ))}
                                        <button className={styles.pageBtn} onClick={() => setProductPage(p => Math.min(totalPages, p + 1))} disabled={productPage === totalPages}>다음</button>
                                    </div>
                                )}
                            </>
                        );
                    })()}
                </div>
            )}

            {/* 배너 관리 */}
            {activeTab === 'banners' && (
                <div>
                    <div className={styles.productHeader}>
                        <h3 className={styles.sectionTitle}>메인 슬라이더 배너</h3>
                        <button className={styles.saveBtn} onClick={() => { setEditingBanner(null); setBannerForm({ title: '', linkType: 'NONE', linkValue: '', sortOrder: banners.length, isActive: true }); setShowBannerForm(true); }}>+ 배너 등록</button>
                    </div>
                    <p className={styles.settingsDesc}>배너는 sortOrder 순서대로 슬라이드됩니다. 숫자가 낮을수록 먼저 표시됩니다.</p>
                    <table className={styles.table}>
                        <thead><tr><th>순서</th><th>이미지</th><th>제목</th><th>링크</th><th>상태</th><th>관리</th></tr></thead>
                        <tbody>
                            {banners.map(banner => (
                                <tr key={banner.bannerId}>
                                    <td>{banner.sortOrder}</td>
                                    <td><img src={`${API_URL}${banner.imageUrl}`} alt={banner.title} className={styles.productThumb} /></td>
                                    <td>{banner.title || '-'}</td>
                                    <td><span className={styles.subText}>{banner.linkType}{banner.linkValue && ` → ${banner.linkValue}`}</span></td>
                                    <td><span className={banner.isActive ? styles.status_ON_SALE : styles.status_HIDDEN}>{banner.isActive ? '노출중' : '숨김'}</span></td>
                                    <td>
                                        <div className={styles.btnGroup}>
                                            <button className={styles.editBtn} onClick={() => handleBannerEdit(banner)}>수정</button>
                                            <button className={styles.deleteBtn} onClick={() => handleBannerDelete(banner.bannerId)}>삭제</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 이벤트 관리 */}
            {activeTab === 'events' && (
                <div>
                    <div className={styles.productHeader}>
                        <h3 className={styles.sectionTitle}>이벤트 관리</h3>
                        <button className={styles.saveBtn} onClick={() => { setEditingEvent(null); setEventForm({ title: '', content: '', isActive: true }); setShowEventForm(true); }}>+ 이벤트 등록</button>
                    </div>
                    <table className={styles.table}>
                        <thead><tr><th>썸네일</th><th>제목</th><th>상태</th><th>등록일</th><th>관리</th></tr></thead>
                        <tbody>
                            {events.map(event => (
                                <tr key={event.eventId}>
                                    <td>
                                        {event.thumbnailUrl
                                            ? <img src={`${API_URL}${event.thumbnailUrl}`} alt={event.title} className={styles.productThumb} />
                                            : <div className={styles.noThumb}>이미지 없음</div>}
                                    </td>
                                    <td>{event.title}</td>
                                    <td><span className={event.isActive ? styles.status_ON_SALE : styles.status_HIDDEN}>{event.isActive ? '진행중' : '종료'}</span></td>
                                    <td>{new Date(event.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        <div className={styles.btnGroup}>
                                            <button className={styles.editBtn} onClick={() => handleEventEdit(event)}>수정</button>
                                            <button className={styles.deleteBtn} onClick={() => handleEventDelete(event.eventId)}>삭제</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 띠 배너 관리 */}
            {activeTab === 'notice' && (
                <div>
                    <div className={styles.productHeader}>
                        <h3 className={styles.sectionTitle}>띠 배너 관리</h3>
                        <button className={styles.saveBtn} onClick={() => { setEditingNoticeBanner(null); setNoticeBannerForm({ content: '', bgColor: '#111111', textColor: '#ffffff', linkType: 'NONE', linkValue: '', sortOrder: noticeBanners.length, isActive: true }); setShowNoticeBannerForm(true); }}>+ 띠 배너 등록</button>
                    </div>
                    <p className={styles.settingsDesc}>3초마다 순환 표시됩니다. sortOrder 숫자가 낮을수록 먼저 표시됩니다.</p>
                    <table className={styles.table}>
                        <thead><tr><th>순서</th><th>미리보기</th><th>내용</th><th>링크</th><th>상태</th><th>관리</th></tr></thead>
                        <tbody>
                            {noticeBanners.map(banner => (
                                <tr key={banner.noticeBannerId}>
                                    <td>{banner.sortOrder}</td>
                                    <td>
                                        <div style={{ background: banner.bgColor, color: banner.textColor, padding: '6px 12px', borderRadius: '4px', fontSize: '12px', whiteSpace: 'nowrap' }}>
                                            {banner.content}
                                        </div>
                                    </td>
                                    <td>{banner.content}</td>
                                    <td><span className={styles.subText}>{banner.linkType}{banner.linkValue && ` → ${banner.linkValue}`}</span></td>
                                    <td><span className={banner.isActive ? styles.status_ON_SALE : styles.status_HIDDEN}>{banner.isActive ? '노출중' : '숨김'}</span></td>
                                    <td>
                                        <div className={styles.btnGroup}>
                                            <button className={styles.editBtn} onClick={() => handleNoticeBannerEdit(banner)}>수정</button>
                                            <button className={styles.deleteBtn} onClick={() => handleNoticeBannerDelete(banner.noticeBannerId)}>삭제</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 카테고리 관리 */}
            {activeTab === 'categories' && (
                <div>
                    <div className={styles.productHeader}>
                        <h3 className={styles.sectionTitle}>카테고리 관리</h3>
                        <button className={styles.saveBtn} onClick={() => { setCategoryForm({ name: '', parentId: '' }); setShowCategoryForm(true); }}>+ 카테고리 등록</button>
                    </div>
                    <p className={styles.settingsDesc}>대분류 삭제 시 하위 카테고리를 먼저 삭제해야 합니다. 상품이 있는 카테고리는 삭제할 수 없습니다.</p>
                    {categoryTree.map(parent => (
                        <div key={parent.categoryId} className={styles.categoryBlock}>
                            <div className={styles.categoryParentRow}>
                                {editingCategory === parent.categoryId ? (
                                    <div className={styles.categoryEditRow}>
                                        <input value={editingCategoryName} onChange={e => setEditingCategoryName(e.target.value)} className={styles.formInput} style={{ width: '200px' }} />
                                        <button className={styles.saveBtn} onClick={() => handleUpdateCategory(parent.categoryId)}>저장</button>
                                        <button className={styles.cancelBtn} onClick={() => setEditingCategory(null)}>취소</button>
                                    </div>
                                ) : (
                                    <div className={styles.categoryEditRow}>
                                        <span className={styles.categoryParentName}>📁 {parent.name}</span>
                                        <button className={styles.editBtn} onClick={() => { setEditingCategory(parent.categoryId); setEditingCategoryName(parent.name); }}>수정</button>
                                        <button className={styles.deleteBtn} onClick={() => handleDeleteCategory(parent.categoryId)}>삭제</button>
                                        <button className={styles.addSubBtn} onClick={() => { setCategoryForm({ name: '', parentId: parent.categoryId }); setShowCategoryForm(true); }}>+ 하위 추가</button>
                                    </div>
                                )}
                            </div>
                            {parent.children?.map(child => (
                                <div key={child.categoryId} className={styles.categoryChildRow}>
                                    {editingCategory === child.categoryId ? (
                                        <div className={styles.categoryEditRow}>
                                            <input value={editingCategoryName} onChange={e => setEditingCategoryName(e.target.value)} className={styles.formInput} style={{ width: '200px' }} />
                                            <button className={styles.saveBtn} onClick={() => handleUpdateCategory(child.categoryId)}>저장</button>
                                            <button className={styles.cancelBtn} onClick={() => setEditingCategory(null)}>취소</button>
                                        </div>
                                    ) : (
                                        <div className={styles.categoryEditRow}>
                                            <span className={styles.categoryChildName}>└ {child.name}</span>
                                            <button className={styles.editBtn} onClick={() => { setEditingCategory(child.categoryId); setEditingCategoryName(child.name); }}>수정</button>
                                            <button className={styles.deleteBtn} onClick={() => handleDeleteCategory(child.categoryId)}>삭제</button>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            )}

            {/* 네비게이션 관리 */}
            {activeTab === 'navigation' && (
                <div>
                    <div className={styles.productHeader}>
                        <h3 className={styles.sectionTitle}>네비게이션 메뉴 관리</h3>
                        <button className={styles.saveBtn} onClick={() => { setEditingNavMenu(null); setNavMenuForm({ label: '', linkType: 'NONE', linkValue: '', sortOrder: navMenus.length, isActive: true }); setShowNavMenuForm(true); }}>+ 메뉴 추가</button>
                    </div>
                    <p className={styles.settingsDesc}>sortOrder 숫자가 낮을수록 왼쪽에 표시됩니다. CATEGORY 타입은 해당 대분류의 소분류가 드롭다운으로 표시됩니다.</p>
                    <table className={styles.table}>
                        <thead><tr><th>순서</th><th>메뉴명</th><th>타입</th><th>연결</th><th>상태</th><th>관리</th></tr></thead>
                        <tbody>
                            {navMenus.map(menu => (
                                <tr key={menu.navMenuId}>
                                    <td>{menu.sortOrder}</td>
                                    <td><strong>{menu.label}</strong></td>
                                    <td><span className={styles.subText}>{menu.linkType}</span></td>
                                    <td><span className={styles.subText}>{menu.linkValue || '-'}</span></td>
                                    <td><span className={menu.isActive ? styles.status_ON_SALE : styles.status_HIDDEN}>{menu.isActive ? '노출중' : '숨김'}</span></td>
                                    <td>
                                        <div className={styles.btnGroup}>
                                            <button className={styles.editBtn} onClick={() => handleNavMenuEdit(menu)}>수정</button>
                                            <button className={styles.deleteBtn} onClick={() => handleNavMenuDelete(menu.navMenuId)}>삭제</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 게시판 관리 */}
            {activeTab === 'boards' && (
                <div>
                    <div className={styles.productHeader}>
                        <h3 className={styles.sectionTitle}>게시판 관리</h3>
                        <button className={styles.saveBtn} onClick={() => window.open('/boards/write', '_self')}>+ 글 작성</button>
                    </div>
                    <div className={styles.searchBar}>
                        <input type="text" placeholder="제목 검색" value={boardSearch} onChange={e => setBoardSearch(e.target.value)} className={styles.searchInput} />
                    </div>
                    <p className={styles.resultCount}>총 {boards.filter(b => b.title?.includes(boardSearch)).length}건</p>
                    <table className={styles.table}>
                        <thead><tr><th>번호</th><th>분류</th><th>제목</th><th>작성자</th><th>조회</th><th>등록일</th><th>관리</th></tr></thead>
                        <tbody>
                            {boards.filter(b => b.title?.includes(boardSearch)).map(board => (
                                <tr key={board.boardId}>
                                    <td>{board.boardId}</td>
                                    <td><span className={styles[`badge_${board.category}`] || ''}>{board.category === 'NOTICE' ? '공지' : board.category === 'EVENT' ? '이벤트' : '자유'}</span></td>
                                    <td>
                                        {board.isPinned && <span>📌 </span>}
                                        <span style={{ cursor: 'pointer', color: '#333' }} onClick={() => window.open(`/boards/${board.boardId}`, '_self')}>{board.title}</span>
                                    </td>
                                    <td>{board.userName}</td>
                                    <td>{board.viewCount}</td>
                                    <td>{new Date(board.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        <div className={styles.btnGroup}>
                                            <button className={styles.editBtn} onClick={() => window.open(`/boards/edit/${board.boardId}`, '_self')}>수정</button>
                                            <button className={styles.deleteBtn}
                                                onClick={async () => {
                                                    const ok = await showConfirm('삭제하시겠습니까?');
                                                    if (!ok) return;
                                                    try {
                                                        await axios.delete(`${API_URL}/api/boards/${board.boardId}`, { headers: { Authorization: `Bearer ${getToken()}` } });
                                                        setBoards(prev => prev.filter(b => b.boardId !== board.boardId));
                                                    } catch { await showAlert('삭제에 실패했습니다.', 'error'); }
                                                }}>삭제</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 리뷰 관리 */}
            {activeTab === 'reviews' && (
                <div>
                    <div className={styles.productHeader}><h3 className={styles.sectionTitle}>리뷰 관리</h3></div>
                    <div className={styles.searchBar}>
                        <input type="text" placeholder="상품명 또는 작성자 검색" value={reviewSearch} onChange={e => setReviewSearch(e.target.value)} className={styles.searchInput} />
                    </div>
                    <p className={styles.resultCount}>총 {reviews.filter(r => r.productName?.includes(reviewSearch) || r.userName?.includes(reviewSearch)).length}건</p>
                    <table className={styles.table}>
                        <thead><tr><th>번호</th><th>상품명</th><th>작성자</th><th>별점</th><th>내용</th><th>이미지</th><th>작성일</th><th>관리</th></tr></thead>
                        <tbody>
                            {reviews.filter(r => r.productName?.includes(reviewSearch) || r.userName?.includes(reviewSearch)).map(review => (
                                <tr key={review.reviewId}>
                                    <td>{review.reviewId}</td>
                                    <td>{review.productName}</td>
                                    <td>{review.userName}</td>
                                    <td>♥ {review.rating}.0</td>
                                    <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{review.content}</td>
                                    <td>{review.imageUrl ? <img src={`${API_URL}${review.imageUrl}`} alt="리뷰" className={styles.productThumb} /> : '-'}</td>
                                    <td>{new Date(review.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        <button className={styles.deleteBtn}
                                            onClick={async () => {
                                                const ok = await showConfirm('리뷰를 삭제하시겠습니까?');
                                                if (!ok) return;
                                                try {
                                                    await deleteReview(review.reviewId);
                                                    setReviews(prev => prev.filter(r => r.reviewId !== review.reviewId));
                                                } catch { await showAlert('삭제에 실패했습니다.', 'error'); }
                                            }}>삭제</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* 사이트 설정 */}
            {activeTab === 'settings' && (
                <div>
                    <div className={styles.settingsSection}>
                        <h3 className={styles.sectionTitle}>쇼핑몰 기본 정보</h3>
                        <div className={styles.formGroup}><label>쇼핑몰 이름</label><input value={settingsForm.shop_name || ''} onChange={e => setSettingsForm(prev => ({ ...prev, shop_name: e.target.value }))} className={styles.formInput} /></div>
                        <div className={styles.formGroup}><label>대표 전화번호</label><input value={settingsForm.shop_phone || ''} onChange={e => setSettingsForm(prev => ({ ...prev, shop_phone: e.target.value }))} className={styles.formInput} /></div>
                        <div className={styles.formGroup}><label>사업장 주소</label><input value={settingsForm.shop_address || ''} onChange={e => setSettingsForm(prev => ({ ...prev, shop_address: e.target.value }))} className={styles.formInput} /></div>
                        <div className={styles.formGroup}><label>사업자 번호</label><input value={settingsForm.shop_business_number || ''} onChange={e => setSettingsForm(prev => ({ ...prev, shop_business_number: e.target.value }))} className={styles.formInput} /></div>
                        <div className={styles.formGroup}><label>대표 이메일</label><input value={settingsForm.shop_email || ''} onChange={e => setSettingsForm(prev => ({ ...prev, shop_email: e.target.value }))} className={styles.formInput} /></div>
                        <div className={styles.formGroup}><label>대표자명</label><input value={settingsForm.shop_owner || ''} onChange={e => setSettingsForm(prev => ({ ...prev, shop_owner: e.target.value }))} className={styles.formInput} /></div>
                        <div className={styles.formGroup}><label>통신판매업 신고번호</label><input value={settingsForm.shop_trade_number || ''} onChange={e => setSettingsForm(prev => ({ ...prev, shop_trade_number: e.target.value }))} className={styles.formInput} /></div>
                        <h3 className={styles.sectionTitle} style={{ marginTop: '32px' }}>배송비 정책</h3>
                        <div className={styles.formGroup}>
                            <label>기본 배송비 (원)</label>
                            <input type="number" value={settingsForm.delivery_fee || ''} onChange={e => setSettingsForm(prev => ({ ...prev, delivery_fee: e.target.value }))} className={styles.formInput} placeholder="예: 3000" />
                        </div>
                        <div className={styles.formGroup}>
                            <label>무료배송 기준금액 (원)</label>
                            <input type="number" value={settingsForm.free_delivery_min || ''} onChange={e => setSettingsForm(prev => ({ ...prev, free_delivery_min: e.target.value }))} className={styles.formInput} placeholder="예: 50000 (0 입력 시 항상 유료)" />
                        </div>
                    </div>
                    <div className={styles.settingsSection}>
                        <h3 className={styles.sectionTitle}>메인 추천 상품</h3>
                        <p className={styles.settingsDesc}>메인 페이지에 노출할 상품을 선택하세요. (최대 8개)</p>
                        <div className={styles.featuredProducts}>
                            {products.map(product => {
                                const featured = (settingsForm.main_featured_products || '').split(',').filter(Boolean);
                                const isSelected = featured.includes(String(product.productId));
                                return (
                                    <div key={product.productId}
                                        className={`${styles.featuredItem} ${isSelected ? styles.featuredSelected : ''}`}
                                        onClick={async () => {
                                            const current = (settingsForm.main_featured_products || '').split(',').filter(Boolean);
                                            let next;
                                            if (isSelected) { next = current.filter(id => id !== String(product.productId)); }
                                            else {
                                                if (current.length >= 8) { await showAlert('최대 8개까지 선택 가능합니다.', 'warning'); return; }
                                                next = [...current, String(product.productId)];
                                            }
                                            setSettingsForm(prev => ({ ...prev, main_featured_products: next.join(',') }));
                                        }}>
                                        <img src={`${API_URL}${product.imageUrl}`} alt={product.name} className={styles.featuredThumb} />
                                        <p className={styles.featuredName}>{product.name}</p>
                                        {isSelected && <span className={styles.featuredCheck}>✓</span>}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className={styles.formActions}>
                        <button className={styles.saveBtn} onClick={handleSettingsSave}>설정 저장</button>
                    </div>
                </div>
            )}

            {/* 띠 배너 등록/수정 모달 */}
            {showNoticeBannerForm && (
                <div className={styles.modalOverlay} onClick={() => setShowNoticeBannerForm(false)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>{editingNoticeBanner ? '띠 배너 수정' : '띠 배너 등록'}</h3>
                            <button className={styles.closeBtn} onClick={() => setShowNoticeBannerForm(false)}>✕</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.formGroup}><label>내용 *</label><input value={noticeBannerForm.content} onChange={e => setNoticeBannerForm(prev => ({ ...prev, content: e.target.value }))} className={styles.formInput} placeholder="띠 배너에 표시될 텍스트" /></div>
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}>
                                    <label>배경색</label>
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <input type="color" value={noticeBannerForm.bgColor} onChange={e => setNoticeBannerForm(prev => ({ ...prev, bgColor: e.target.value }))} style={{ width: '48px', height: '36px', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer' }} />
                                        <input value={noticeBannerForm.bgColor} onChange={e => setNoticeBannerForm(prev => ({ ...prev, bgColor: e.target.value }))} className={styles.formInput} placeholder="#111111" />
                                    </div>
                                </div>
                                <div className={styles.formGroup}>
                                    <label>텍스트색</label>
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <input type="color" value={noticeBannerForm.textColor} onChange={e => setNoticeBannerForm(prev => ({ ...prev, textColor: e.target.value }))} style={{ width: '48px', height: '36px', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer' }} />
                                        <input value={noticeBannerForm.textColor} onChange={e => setNoticeBannerForm(prev => ({ ...prev, textColor: e.target.value }))} className={styles.formInput} placeholder="#ffffff" />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.formGroup}>
                                <label>미리보기</label>
                                <div style={{ background: noticeBannerForm.bgColor, color: noticeBannerForm.textColor, padding: '10px', textAlign: 'center', fontSize: '14px', borderRadius: '4px' }}>
                                    {noticeBannerForm.content || '띠 배너 미리보기'}
                                </div>
                            </div>
                            <div className={styles.formGroup}>
                                <label>클릭 시 이동</label>
                                <select value={noticeBannerForm.linkType} onChange={e => setNoticeBannerForm(prev => ({ ...prev, linkType: e.target.value, linkValue: '' }))} className={styles.formInput}>
                                    <option value="NONE">링크 없음</option>
                                    <option value="EVENT">이벤트 페이지</option>
                                    <option value="PRODUCT">상품 페이지</option>
                                    <option value="URL">외부 URL</option>
                                </select>
                            </div>
                            {noticeBannerForm.linkType === 'EVENT' && (<div className={styles.formGroup}><label>이벤트 선택</label><select value={noticeBannerForm.linkValue} onChange={e => setNoticeBannerForm(prev => ({ ...prev, linkValue: e.target.value }))} className={styles.formInput}><option value="">이벤트 선택</option>{events.map(ev => <option key={ev.eventId} value={ev.eventId}>{ev.title}</option>)}</select></div>)}
                            {noticeBannerForm.linkType === 'PRODUCT' && (<div className={styles.formGroup}><label>상품 선택</label><select value={noticeBannerForm.linkValue} onChange={e => setNoticeBannerForm(prev => ({ ...prev, linkValue: e.target.value }))} className={styles.formInput}><option value="">상품 선택</option>{products.map(p => <option key={p.productId} value={p.productId}>{p.name}</option>)}</select></div>)}
                            {noticeBannerForm.linkType === 'URL' && (<div className={styles.formGroup}><label>URL</label><input value={noticeBannerForm.linkValue} onChange={e => setNoticeBannerForm(prev => ({ ...prev, linkValue: e.target.value }))} className={styles.formInput} placeholder="https://..." /></div>)}
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}><label>노출 순서</label><input type="number" value={noticeBannerForm.sortOrder} onChange={e => setNoticeBannerForm(prev => ({ ...prev, sortOrder: parseInt(e.target.value) || 0 }))} className={styles.formInput} /></div>
                                <div className={styles.formGroup}><label>노출 상태</label><select value={String(noticeBannerForm.isActive)} onChange={e => setNoticeBannerForm(prev => ({ ...prev, isActive: e.target.value === 'true' }))} className={styles.formInput}><option value="true">노출</option><option value="false">숨김</option></select></div>
                            </div>
                            <div className={styles.formActions}>
                                <button className={styles.cancelBtn} onClick={() => setShowNoticeBannerForm(false)}>취소</button>
                                <button className={styles.saveBtn} onClick={handleNoticeBannerSubmit}>{editingNoticeBanner ? '수정' : '등록'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 카테고리 등록 모달 */}
            {showCategoryForm && (
                <div className={styles.modalOverlay} onClick={() => setShowCategoryForm(false)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()} style={{ maxWidth: '400px' }}>
                        <div className={styles.modalHeader}>
                            <h3>{categoryForm.parentId ? '하위 카테고리 등록' : '대분류 카테고리 등록'}</h3>
                            <button className={styles.closeBtn} onClick={() => setShowCategoryForm(false)}>✕</button>
                        </div>
                        <div className={styles.modalBody}>
                            {categoryForm.parentId && (<div className={styles.formGroup}><label>상위 카테고리</label><input value={categoryTree.find(c => c.categoryId === categoryForm.parentId)?.name || ''} disabled className={styles.formInput} style={{ background: '#f5f5f5' }} /></div>)}
                            {!categoryForm.parentId && (<div className={styles.formGroup}><label>상위 카테고리 (선택)</label><select value={categoryForm.parentId} onChange={e => setCategoryForm(prev => ({ ...prev, parentId: e.target.value ? Number(e.target.value) : '' }))} className={styles.formInput}><option value="">없음 (대분류)</option>{categoryTree.map(c => <option key={c.categoryId} value={c.categoryId}>{c.name}</option>)}</select></div>)}
                            <div className={styles.formGroup}><label>카테고리명 *</label><input value={categoryForm.name} onChange={e => setCategoryForm(prev => ({ ...prev, name: e.target.value }))} className={styles.formInput} placeholder="카테고리명 입력" /></div>
                            <div className={styles.formActions}>
                                <button className={styles.cancelBtn} onClick={() => setShowCategoryForm(false)}>취소</button>
                                <button className={styles.saveBtn} onClick={handleCreateCategory}>등록</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 네비게이션 메뉴 등록/수정 모달 */}
            {showNavMenuForm && (
                <div className={styles.modalOverlay} onClick={() => setShowNavMenuForm(false)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()} style={{ maxWidth: '440px' }}>
                        <div className={styles.modalHeader}>
                            <h3>{editingNavMenu ? '메뉴 수정' : '메뉴 추가'}</h3>
                            <button className={styles.closeBtn} onClick={() => setShowNavMenuForm(false)}>✕</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.formGroup}><label>메뉴명 *</label><input value={navMenuForm.label} onChange={e => setNavMenuForm(prev => ({ ...prev, label: e.target.value }))} className={styles.formInput} placeholder="예: SHOP, BEAUTY, LIVING" /></div>
                            <div className={styles.formGroup}><label>타입</label><select value={navMenuForm.linkType} onChange={e => setNavMenuForm(prev => ({ ...prev, linkType: e.target.value, linkValue: '' }))} className={styles.formInput}><option value="NONE">링크 없음</option><option value="CATEGORY">카테고리 연결</option><option value="URL">직접 URL</option></select></div>
                            {navMenuForm.linkType === 'CATEGORY' && (<div className={styles.formGroup}><label>대분류 카테고리 선택</label><select value={navMenuForm.linkValue} onChange={e => setNavMenuForm(prev => ({ ...prev, linkValue: e.target.value }))} className={styles.formInput}><option value="">카테고리 선택</option><option value="ALL">전체 카테고리</option>{categoryTree.map(c => <option key={c.categoryId} value={String(c.categoryId)}>{c.name}</option>)}</select></div>)}
                            {navMenuForm.linkType === 'URL' && (<div className={styles.formGroup}><label>URL</label><input value={navMenuForm.linkValue} onChange={e => setNavMenuForm(prev => ({ ...prev, linkValue: e.target.value }))} className={styles.formInput} placeholder="예: /, /board, /events" /></div>)}
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}><label>노출 순서</label><input type="number" value={navMenuForm.sortOrder} onChange={e => setNavMenuForm(prev => ({ ...prev, sortOrder: parseInt(e.target.value) || 0 }))} className={styles.formInput} /></div>
                                <div className={styles.formGroup}><label>노출 상태</label><select value={String(navMenuForm.isActive)} onChange={e => setNavMenuForm(prev => ({ ...prev, isActive: e.target.value === 'true' }))} className={styles.formInput}><option value="true">노출</option><option value="false">숨김</option></select></div>
                            </div>
                            <div className={styles.formActions}>
                                <button className={styles.cancelBtn} onClick={() => setShowNavMenuForm(false)}>취소</button>
                                <button className={styles.saveBtn} onClick={handleNavMenuSubmit}>{editingNavMenu ? '수정' : '등록'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 배너 등록/수정 모달 */}
            {showBannerForm && (
                <div className={styles.modalOverlay} onClick={() => setShowBannerForm(false)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>{editingBanner ? '배너 수정' : '배너 등록'}</h3>
                            <button className={styles.closeBtn} onClick={() => setShowBannerForm(false)}>✕</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.formGroup}>
                                <label>배너 이미지 {!editingBanner && '*'}</label>
                                <input type="file" accept="image/*" onChange={e => setBannerImageFile(e.target.files[0])} className={styles.formInput} />
                                {editingBanner && (<><p className={styles.settingsDesc}>이미지를 선택하지 않으면 기존 이미지가 유지됩니다.</p><img src={`${API_URL}${editingBanner.imageUrl}`} alt="현재 배너" style={{ width: '100%', marginTop: '8px', borderRadius: '4px' }} /></>)}
                            </div>
                            <div className={styles.formGroup}><label>배너 제목 (선택)</label><input value={bannerForm.title} onChange={e => setBannerForm(prev => ({ ...prev, title: e.target.value }))} className={styles.formInput} placeholder="배너 위에 표시될 텍스트" /></div>
                            <div className={styles.formGroup}><label>클릭 시 이동</label><select value={bannerForm.linkType} onChange={e => setBannerForm(prev => ({ ...prev, linkType: e.target.value, linkValue: '' }))} className={styles.formInput}><option value="NONE">링크 없음</option><option value="EVENT">이벤트 페이지</option><option value="PRODUCT">상품 페이지</option><option value="URL">외부 URL</option></select></div>
                            {bannerForm.linkType === 'EVENT' && (<div className={styles.formGroup}><label>이벤트 선택</label><select value={bannerForm.linkValue} onChange={e => setBannerForm(prev => ({ ...prev, linkValue: e.target.value }))} className={styles.formInput}><option value="">이벤트 선택</option>{events.map(ev => <option key={ev.eventId} value={ev.eventId}>{ev.title}</option>)}</select></div>)}
                            {bannerForm.linkType === 'PRODUCT' && (<div className={styles.formGroup}><label>상품 선택</label><select value={bannerForm.linkValue} onChange={e => setBannerForm(prev => ({ ...prev, linkValue: e.target.value }))} className={styles.formInput}><option value="">상품 선택</option>{products.map(p => <option key={p.productId} value={p.productId}>{p.name}</option>)}</select></div>)}
                            {bannerForm.linkType === 'URL' && (<div className={styles.formGroup}><label>URL</label><input value={bannerForm.linkValue} onChange={e => setBannerForm(prev => ({ ...prev, linkValue: e.target.value }))} className={styles.formInput} placeholder="https://..." /></div>)}
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}><label>노출 순서</label><input type="number" value={bannerForm.sortOrder} onChange={e => setBannerForm(prev => ({ ...prev, sortOrder: parseInt(e.target.value) || 0 }))} className={styles.formInput} /></div>
                                <div className={styles.formGroup}><label>노출 상태</label><select value={String(bannerForm.isActive)} onChange={e => setBannerForm(prev => ({ ...prev, isActive: e.target.value === 'true' }))} className={styles.formInput}><option value="true">노출</option><option value="false">숨김</option></select></div>
                            </div>
                            <div className={styles.formActions}>
                                <button className={styles.cancelBtn} onClick={() => setShowBannerForm(false)}>취소</button>
                                <button className={styles.saveBtn} onClick={handleBannerSubmit}>{editingBanner ? '수정' : '등록'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 이벤트 등록/수정 모달 */}
            {showEventForm && (
                <div className={styles.modalOverlay} onClick={() => setShowEventForm(false)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>{editingEvent ? '이벤트 수정' : '이벤트 등록'}</h3>
                            <button className={styles.closeBtn} onClick={() => setShowEventForm(false)}>✕</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.formGroup}><label>이벤트 제목 *</label><input value={eventForm.title} onChange={e => setEventForm(prev => ({ ...prev, title: e.target.value }))} className={styles.formInput} placeholder="이벤트 제목" /></div>
                            <div className={styles.formGroup}><label>썸네일 이미지</label><input type="file" accept="image/*" onChange={e => setEventThumbnailFile(e.target.files[0])} className={styles.formInput} />{editingEvent?.thumbnailUrl && <img src={`${API_URL}${editingEvent.thumbnailUrl}`} alt="현재 썸네일" style={{ width: '200px', marginTop: '8px', borderRadius: '4px' }} />}</div>
                            <div className={styles.formGroup}><label>이벤트 내용</label><RichEditor value={eventForm.content} onChange={value => setEventForm(prev => ({ ...prev, content: value }))} /></div>
                            <div className={styles.formGroup}><label>상태</label><select value={String(eventForm.isActive)} onChange={e => setEventForm(prev => ({ ...prev, isActive: e.target.value === 'true' }))} className={styles.formInput}><option value="true">진행중</option><option value="false">종료</option></select></div>
                            <div className={styles.formActions}>
                                <button className={styles.cancelBtn} onClick={() => setShowEventForm(false)}>취소</button>
                                <button className={styles.saveBtn} onClick={handleEventSubmit}>{editingEvent ? '수정' : '등록'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 상품 등록 모달 */}
            {showProductForm && (
                <div className={styles.modalOverlay} onClick={() => setShowProductForm(false)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>상품 등록</h3>
                            <button className={styles.closeBtn} onClick={() => setShowProductForm(false)}>✕</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.formGroup}><label>상품명 *</label><input name="name" value={productForm.name} onChange={handleProductFormChange} className={styles.formInput} placeholder="상품명" /></div>
                            <div className={styles.formGroup}><label>카테고리 *</label><select name="categoryId" value={productForm.categoryId} onChange={handleProductFormChange} className={styles.formInput}><option value="">카테고리 선택</option>{categories.map(c => <option key={c.categoryId} value={c.categoryId}>{c.name}</option>)}</select></div>
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}><label>판매가 *</label><input name="price" type="number" value={productForm.price} onChange={handleProductFormChange} className={styles.formInput} placeholder="0" /></div>
                                <div className={styles.formGroup}><label>원가 (할인 전)</label><input name="originalPrice" type="number" value={productForm.originalPrice} onChange={handleProductFormChange} className={styles.formInput} placeholder="0" /></div>
                                <div className={styles.formGroup}><label>할인율 (%)</label><input name="discountRate" type="number" value={productForm.discountRate} onChange={handleProductFormChange} className={styles.formInput} placeholder="0" /></div>
                            </div>
                            <div className={styles.formGroup}><label>재고 *</label><input name="stock" type="number" value={productForm.stock} onChange={handleProductFormChange} className={styles.formInput} placeholder="0" /></div>
                            <div className={styles.formGroup}><label>개별 배송비 (원, 미입력 시 기본 정책 적용)</label><input name="deliveryFee" type="number" value={productForm.deliveryFee || ''} onChange={handleProductFormChange} className={styles.formInput} placeholder="미입력 시 기본 배송비 적용" /></div>
                            <div className={styles.formGroup}><label>상품 설명</label><RichEditor value={productForm.description} onChange={value => setProductForm(prev => ({ ...prev, description: value }))} /></div>
                            <div className={styles.formGroup}><label>대표 이미지</label><input type="file" accept="image/*" onChange={e => setProductImageFile(e.target.files[0])} className={styles.formInput} /></div>
                            <div className={styles.formGroup}><label>추가 이미지 (여러 장 선택 가능)</label><input type="file" accept="image/*" multiple onChange={e => setProductImageFiles(Array.from(e.target.files))} className={styles.formInput} /></div>
                            <div className={styles.formActions}>
                                <button className={styles.cancelBtn} onClick={() => setShowProductForm(false)}>취소</button>
                                <button className={styles.saveBtn} onClick={handleCreateProduct}>등록</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 상품 수정 모달 */}
            {showEditModal && editForm && (
                <div className={styles.modalOverlay} onClick={() => setShowEditModal(false)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>상품 수정 - {editForm.name}</h3>
                            <div className={styles.formGroup}>
                                <label>상품명</label>
                                <input type="text" value={editForm.name || ''} onChange={e => setEditForm({ ...editForm, name: e.target.value })} className={styles.formInput} />
                            </div>
                            <div className={styles.formGroup}>
                                <label>카테고리</label>
                                <select value={editForm.categoryId || ''} onChange={e => setEditForm(prev => ({ ...prev, categoryId: e.target.value }))} className={styles.formInput}>
                                    <option value="">카테고리 선택</option>
                                    {categoryTree.map(parent => (
                                        <optgroup key={parent.categoryId} label={parent.name}>
                                            {parent.children?.map(child => (<option key={child.categoryId} value={child.categoryId}>{child.name}</option>))}
                                        </optgroup>
                                    ))}
                                </select>
                            </div>
                            <button className={styles.closeBtn} onClick={() => setShowEditModal(false)}>✕</button>
                        </div>
                        <div className={styles.modalBody}>
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}><label>판매가 *</label><input type="number" value={editForm.price} onChange={e => setEditForm({ ...editForm, price: e.target.value })} className={styles.formInput} /></div>
                                <div className={styles.formGroup}><label>원가</label><input type="number" value={editForm.originalPrice || ''} onChange={e => setEditForm({ ...editForm, originalPrice: e.target.value })} className={styles.formInput} /></div>
                                <div className={styles.formGroup}><label>할인율 (%)</label><input type="number" value={editForm.discountRate || 0} onChange={e => setEditForm({ ...editForm, discountRate: e.target.value })} className={styles.formInput} /></div>
                            </div>
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}><label>재고 *</label><input type="number" value={editForm.stock} onChange={e => setEditForm({ ...editForm, stock: e.target.value })} className={styles.formInput} /></div>
                                <div className={styles.formGroup}><label>개별 배송비 (원, 미입력 시 기본 정책 적용)</label><input type="number" value={editForm.deliveryFee || ''} onChange={e => setEditForm({ ...editForm, deliveryFee: e.target.value })} className={styles.formInput} placeholder="미입력 시 기본 배송비 적용" /></div>
                                <div className={styles.formGroup}><label>상태</label><select value={editForm.status} onChange={e => setEditForm({ ...editForm, status: e.target.value })} className={styles.formInput}><option value="ON_SALE">판매중</option><option value="SOLD_OUT">품절</option><option value="HIDDEN">숨김</option></select></div>
                            </div>
                            <div className={styles.formGroup}><label>상품 설명</label><RichEditor value={editForm.description || ''} onChange={value => setEditForm(prev => ({ ...prev, description: value }))} /></div>
                            <div className={styles.formGroup}>
                                <label>대표 이미지 교체</label>
                                    {editForm.imageUrl && (
                                        <div style={{ position: 'relative', display: 'inline-block', marginBottom: '8px' }}>
                                            <img src={`${API_URL}${editForm.imageUrl}`} alt="현재 이미지" style={{ width: '100px', height: '100px', objectFit: 'cover', display: 'block' }} />
                                            <button type="button" onClick={() => setEditForm(prev => ({ ...prev, imageUrl: null }))}
                                                style={{ position: 'absolute', top: '2px', right: '2px', background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '12px', lineHeight: '1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
                                        </div>
                                    )}
                                    <input type="file" accept="image/*" onChange={e => setEditImageFile(e.target.files[0])} className={styles.formInput} />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>추가 이미지</label>
                                    {editForm.images?.length > 0 && (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '8px' }}>
                                            {editForm.images.map((img, i) => (
                                                <div key={img.imageId} style={{ position: 'relative' }}>
                                                    <img src={`${API_URL}${img.imageUrl}`} alt={`추가이미지${i+1}`} style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                                                    <button type="button" onClick={async () => {
                                                            const ok = await showConfirm('이미지를 삭제하시겠습니까?');
                                                            if (!ok) return;
                                                            try {
                                                                await deleteProductImage(editForm.productId, img.imageId);
                                                                setEditForm(prev => ({ ...prev, images: prev.images.filter(im => im.imageId !== img.imageId) }));
                                                                await showAlert('이미지가 삭제되었습니다', 'success');
                                                            } catch { await showAlert('이미지 삭제에 실패했습니다.', 'error'); }
                                                        }}
                                                        style={{ position: 'absolute', top: '2px', right: '2px', background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '12px', lineHeight: '1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    <input type="file" accept="image/*" multiple onChange={e => setEditImageFiles(Array.from(e.target.files))} className={styles.formInput} />
                                </div>
                            <div className={styles.formGroup}>
                                <label>옵션 관리</label>
                                {productOptions.length > 0 && (
                                    <div className={styles.optionList}>
                                        {productOptions.map(opt => (
                                            <div key={opt.optionId} className={styles.optionItem}>
                                                <span className={styles.optionBadge}>{opt.optionName}</span>
                                                <span>{opt.optionValue}</span>
                                                {opt.additionalPrice > 0 && <span className={styles.optionPrice}>+{opt.additionalPrice.toLocaleString()}원</span>}
                                                <span className={styles.optionStock}>재고 {opt.stock}개</span>
                                                <button className={styles.deleteBtn} onClick={() => handleDeleteOption(opt.optionId)}>삭제</button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div className={styles.optionForm}>
                                    <div className={styles.optionFormRow}>
                                        <input placeholder="옵션명 (예: 색상)" value={newOption.optionName} onChange={e => setNewOption(prev => ({ ...prev, optionName: e.target.value }))} className={styles.formInput} />
                                        <input placeholder="옵션값 (예: 빨강)" value={newOption.optionValue} onChange={e => setNewOption(prev => ({ ...prev, optionValue: e.target.value }))} className={styles.formInput} />
                                        <input type="number" placeholder="추가금액" value={newOption.additionalPrice} onChange={e => setNewOption(prev => ({ ...prev, additionalPrice: parseInt(e.target.value) || 0 }))} className={styles.formInput} />
                                        <input type="number" placeholder="재고" value={newOption.stock} onChange={e => setNewOption(prev => ({ ...prev, stock: parseInt(e.target.value) || 0 }))} className={styles.formInput} />
                                        <button className={styles.saveBtn} onClick={handleAddOption}>추가</button>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.formActions}>
                                <button className={styles.cancelBtn} onClick={() => setShowEditModal(false)}>취소</button>
                                <button className={styles.saveBtn} onClick={handleProductSave}>저장</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 주문 상세 모달 */}
            {selectedOrder && (
                <div className={styles.modalOverlay} onClick={() => setSelectedOrder(null)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>주문 상세 #{selectedOrder.orderId}</h3>
                            <button className={styles.closeBtn} onClick={() => setSelectedOrder(null)}>✕</button>
                        </div>
                        {orderDetailLoading ? <p>로딩 중...</p> : (
                            <div className={styles.modalBody}>
                                <div className={styles.modalSection}><h4>주문자 정보</h4><p>{selectedOrder.user?.name} · {selectedOrder.user?.phone}</p><p>{selectedOrder.user?.email}</p></div>
                                <div className={styles.modalSection}><h4>배송지</h4><p>{selectedOrder.address?.recipient} · {selectedOrder.address?.phone}</p><p>[{selectedOrder.address?.zipcode}] {selectedOrder.address?.address1} {selectedOrder.address?.address2}</p></div>
                                <div className={styles.modalSection}>
                                    <h4>주문 상품</h4>
                                    {selectedOrder.orderItems?.map((item, i) => (
                                        <div key={i} className={styles.modalItem}>
                                            <img src={`${API_URL}${item.imageUrl}`} alt={item.productName} className={styles.modalItemImage} />
                                            <div><p>{item.productName}</p><p className={styles.subText}>{item.quantity}개 · {item.price?.toLocaleString()}원</p></div>
                                        </div>
                                    ))}
                                </div>
                                <div className={styles.modalSection}>
                                    <h4>결제 정보</h4>
                                    <div className={styles.modalTotal}><span>상품 금액</span><span>{(selectedOrder.totalPrice - (selectedOrder.deliveryFee || 0))?.toLocaleString()}원</span></div>
                                    <div className={styles.modalTotal}><span>배송비</span><span>{selectedOrder.deliveryFee > 0 ? `${selectedOrder.deliveryFee?.toLocaleString()}원` : '무료'}</span></div>
                                    <div className={styles.modalTotal}><span>총 결제금액</span><span><strong>{selectedOrder.totalPrice?.toLocaleString()}원</strong></span></div>
                                    <p className={styles.subText}>상태: {statusLabels[selectedOrder.status]}</p>
                                    <p className={styles.subText}>주문일: {new Date(selectedOrder.createdAt).toLocaleString()}</p>
                                </div>
                                <div className={styles.modalSection}>
                                    <h4>배송 정보</h4>
                                    {selectedOrder.courierName ? (
                                        <p className={styles.subText}>{selectedOrder.courierName} · {selectedOrder.trackingNumber}</p>
                                    ) : (
                                        <p className={styles.subText}>운송장 정보 없음</p>
                                    )}
                                    <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
                                        <select value={shippingForm.courierName} onChange={e => setShippingForm(prev => ({ ...prev, courierName: e.target.value }))} className={styles.select}>
                                            <option value="">택배사 선택</option>
                                            <option value="CJ대한통운">CJ대한통운</option>
                                            <option value="롯데택배">롯데택배</option>
                                            <option value="한진택배">한진택배</option>
                                            <option value="우체국택배">우체국택배</option>
                                            <option value="로젠택배">로젠택배</option>
                                            <option value="편의점택배">편의점택배</option>
                                        </select>
                                        <input type="text" placeholder="운송장 번호" value={shippingForm.trackingNumber} onChange={e => setShippingForm(prev => ({ ...prev, trackingNumber: e.target.value }))} className={styles.select} style={{ flex: 1, minWidth: '160px' }} />
                                        <select value={shippingForm.status || selectedOrder.status} onChange={e => setShippingForm(prev => ({ ...prev, status: e.target.value }))} className={styles.select}>
                                            {Object.entries(statusLabels).map(([val, label]) => (<option key={val} value={val}>{label}</option>))}
                                        </select>
                                        <button className={styles.saveBtn} onClick={async () => {
                                            if (!shippingForm.courierName || !shippingForm.trackingNumber) {
                                                await showAlert('택배사와 운송장 번호를 입력해 주세요.', 'warning'); return;
                                            }
                                            try {
                                                const data = { courierName: shippingForm.courierName, trackingNumber: shippingForm.trackingNumber, status: 'SHIPPING' };
                                                await updateShippingInfo(selectedOrder.orderId, data);
                                                setOrders(orders.map(o => o.orderId === selectedOrder.orderId ? { ...o, ...data } : o));
                                                setSelectedOrder(prev => ({ ...prev, ...data }));
                                                setShippingForm({ courierName: '', trackingNumber: '', status: '' });
                                                await showAlert('배송 정보가 저장되었습니다.', 'success');
                                            } catch { await showAlert('저장에 실패했습니다.', 'error'); }
                                        }}>저장</button>
                                    </div>
                                </div>
                                <div style={{ marginTop: '24px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                    <button className={styles.printBtn} onClick={() => handlePrintInvoice(selectedOrder)}>🖨️ 송장 출력</button>
                                    <button className={styles.cancelBtn} onClick={() => setSelectedOrder(null)}>닫기</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminPage;
